import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import CustomAvatar from "../Avatar/Avatar";
const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectEmpresa
 * @description Select para las empresas registradas en el sistema
 */
const SelectEmpresa = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione la empresa", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {} 
    } = props

    const [ empresas, setEmpresas ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getEmpresas
     * @description Obitiene los empresas
     */
    const getEmpresas = ({page, limit, search} = empresas) => {

        axios.get('/empresas', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setEmpresas(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener las empresas')
        })
    }

    //componentDidMount
    useEffect(() => {
        getEmpresas()
    }, [])

    useEffect(() => {
        if(value)
            onChange(value?.value ?? value)
    }, [value])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            onSearch={(search)=> getEmpresas({search})}
            onSelect={(empresa)=> {
                onChange(empresa.value)
                onSelect(empresa.value)
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                empresas?.data?.map(({ _id, alias, color, logo }) => <Option value={_id} key={_id}>
                    <CustomAvatar 
                        size="small"
                        image={axios.defaults.baseURL + '/upload/' + logo} 
                        name={alias} 
                        color={color} 
                    /> 
                    {alias ?? ""}
                </Option>)
            }
        </Select>
    );
}



export default SelectEmpresa;